import { callPinterestAPI } from "@api/utils_2020";
const pbdsFooter = {
    init: function () {
        console.log("pbds-footer: INIT");
        // Toggle Submenus 
        $('.pbds-footer .group > button').on('click',function(){
            if($(window).width() < 770) {
                $(this).siblings('.submenu').toggle('blind',{direction: "up"},300);
            }
            return false;
        });

        $('.pbds-footer form.formNewsletter #email').on('change', function(){
            if (validateEmail($(this).val()))
            {
                $('form.formNewsletter .formSubmit').prop('disabled', false).removeClass('disabled');
            }
            else
            {
                $(this).parent().attr('data-error',"Por favor, digite um e-mail válido!");
                $('form.formNewsletter .formSubmit').prop('disabled', true).addClass('disabled');
            }
        });

        $('.pbds-footer form.formNewsletter #name').on('change', function(){
            if ($(this).val())
            {
                $('form.formNewsletter .formSubmit').prop('disabled', false).removeClass('disabled');
            }
            else
            {
                //$(this).parent().data('error',"Por favor, digite um e-mail válido!");
                $('form.formNewsletter .formSubmit').prop('disabled', true).addClass('disabled');
            }
        });

         // Form captura LEAD
         $('.pbds-footer form.formNewsletter').on('submit', function(e) {
            if ($('button.pbds-btn.full.light.formSubmit').text().includes('ENVIANDO')){
                return false
            }
            //e.preventDefault();
            // TODO: Enviar contato
            // var processing = true;
            var form = $(this);
            var data = {
                type: 'newsletter',
                email: form.find('input[name="email"]').val(),
                name: form.find('input[name="name"]').val(),
                area: channel,
                newsletter: form.find('input[name="optin"]:checked').length > 0 ? 'yes' : 'no'
            };
            if (!validateEmail(data.email))
            {
                $('.pbds-footer form.formNewsletter #email').parent().attr('data-error',"Por favor, digite um e-mail válido!");
                $('form.formNewsletter .formSubmit').prop('disabled', true).addClass('disabled');
                return false;
            }
            
            $('.pbds-footer form.formNewsletter').css('opacity', 0.7);
            $('button.pbds-btn.full.light.formSubmit').prop('disabled', true).addClass('disabled');
            $('button.pbds-btn.full.light.formSubmit').text('ENVIANDO...')


            if (!form.find('input[name="terms"]').is(':checked'))
            {
                $('.pbds-footer form.formNewsletter #terms').parent().attr('data-error',"Precisa aceitar os termos de uso!");
                $('form.formNewsletter .formSubmit').prop('disabled', true).addClass('disabled');
                return false;
            } else {
                $('form.formNewsletter .formSubmit').prop('disabled', false).removeClass('disabled');
            }

            var service = Util.service('WSPortobelloSite', true, {
                exceptionHandler: alertInterface.showError,
                reflectSuccess: function(service) {
                    service.insertNewsletter(data, {
                        success: function(result) {
                            // dispara evento do GA.                            
                            window.dataLayer.push({
                                'event': 'cadastrarNewsletter'
                            });

                            const nameParts = data['name'].split(" ");
                            let sobrenome = "";

                            if(nameParts[1]) {
                                sobrenome = nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1);

                                if(nameParts[2]) {
                                    sobrenome += " " + nameParts[2].charAt(0).toUpperCase() + nameParts[2].slice(1);
                                }
                            }

                            const mktData = {
                                "keys": {
                                "Email": data['email'],
                                "Sub_Origem": "Newsletter"
                                    },
                                "values": {
                                    "Nome": nameParts[0].charAt(0).toUpperCase() +  nameParts[0].slice(1) + " " + sobrenome,
                                    "Primeiro_Nome": nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1),
                                    "Email_Optin": 'TRUE',
                                    "SMS_Optin": 'TRUE',
                                    "Tracking": window.location.href?window.location.href:"https://www.portobello.com.br/",
                                    "Gclid" : $('#gclid').val(),
//                                    "codigo_indoleads" : $('#codigo_indoleads').val()
                                }
                            }

                            Util.service('WSPortobelloSalesFoce', true, {
                                exceptionHandler: alertInterface.showError,
                                reflectSuccess: function(service) {
                                    service.insertMkt(mktData, {
                                        success: result => {
                                            console.log('result', result);
                                        }
                                    })
                                }
                            });
                            
                            if (parseInt(result) > 0) {
                                pintrk('track', 'lead', {
                                    event_id: eventID,
                                    lead_type: 'Newsletter'
                                });
                                callPinterestAPI('lead', { lead_type: 'Newsletter' });
                                $('.pbds-footer form.formNewsletter').fadeOut();
                                $('.pbds-footer div.formSuccess').fadeIn();
                            }
                        }
                    });
                    /*
                    var rdstation = Util.service('WSRdStation', false);
                    //e.preventDefault();                                     
                    if (portobelloShop)
                    {
                        var site  = 'Site Portobello Shop Newsletter';
                        var url = 'https://www.portobelloshop.com.br';
                    }
                    else
                    {
                        var site  = 'Site Portobello SA Newsletter';
                        var url = 'https://www.portobello.com.br';
                    }
                    var dataRd = {
                        email:data.email,
                        name:data.name,
                        website:url
                    };
                    
                    rdstation.insertLead(dataRd,site);
                    */
                }
            });

            return false;
        });

        $('form.formNewsletter #terms').on('change', function() {
            if ($(this).prop('checked')) {
                //alert('Sim!');
                $('form.formNewsletter .formSubmit').prop('disabled', false).removeClass('disabled');
            } else {
                //alert('Não!');
                $('form.formNewsletter .formSubmit').prop('disabled', true).addClass('disabled');
            }
        });
    
    }
}


function capitalizeFirstLetter(name)
{
  const nameParts = name.split(" ");
  let fullName = "";

  if (nameParts[0] && nameParts[1] && nameParts[2]) {
    fullName = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1) + " " + nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1) + " " + nameParts[2].charAt(0).toUpperCase() + nameParts[2].slice(1);
  } else if(nameParts[0] && nameParts[1] ) {
    fullName = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1) + " " + nameParts[1].charAt(0).toUpperCase() + nameParts[1].slice(1);
  }  else {
    fullName = nameParts[0].charAt(0).toUpperCase() + nameParts[0].slice(1);
  }

  return fullName;
}

window.loadedComponents.push({ component: 'pbds-footer', init: pbdsFooter.init});

export default() => {
    pbdsFooter.init();
}